import { PrismicRichText } from "@prismicio/react";
import React from "react";

const titleComponent = {
  heading1: ({ children }) => (
    <h1 className="title-font title-large text-[#1F2223]">{children}</h1>
  ),
  heading2: ({ children }) => (
    <h2 className="title-font title-large text-[#1F2223]">{children}</h2>
  ),
  heading3: ({ children }) => (
    <h3 className="title-font title-large text-[#1F2223]">{children}</h3>
  ),
  paragraph: ({ children }) => (
    <p className="title-font title-large text-[#1F2223]">{children}</p>
  ),
};

const bodyComponent = {
  heading4: ({ children }) => (
    <h4 className="text-medium text-[#1F2223]">{children}</h4>
  ),
  heading5: ({ children }) => (
    <h5 className="text-medium text-[#1F2223]">{children}</h5>
  ),
  heading6: ({ children }) => (
    <h6 className="text-medium text-[#1F2223]">{children}</h6>
  ),
  paragraph: ({ children }) => (
    <p className="text-medium text-[#1F2223]">{children}</p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
};

const CenteredTitle = ({ title, description }) => {
  return (
    <div className="max-w-[568px] mx-auto text-center flex flex-col items-center">
      <PrismicRichText field={title} components={titleComponent} />
      <div className=" hidden md:block w-[76px] h-[2px] bg-[#EEB978] mt-[18px] mb-[10px]"></div>

      <div className="mt-[12px] mb-[32px] xl:mb-[40px]">
        <PrismicRichText field={description} components={bodyComponent} />
      </div>
    </div>
  );
};

export default CenteredTitle;
